import Vue from 'vue';
import Router from 'vue-router';
import layout from './views/layout.vue';
import login from '@/views/account/login.vue';
import register from '@/views/account/register.vue';
import forgetPass from '@/views/account/forgetPass.vue';
import bind from '@/views/account/bind.vue'

Vue.use(Router);
export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/main',
      component: layout,
      children: [
        {
          path: '/',
          redirect: 'keCheng',
        }, {
          path: 'keCheng',
          component: (resolve) => require(['@/views/main/keCheng'], resolve),
        }, {
          path: 'keChengToday',
          component: (resolve) => require(['@/views/main/keChengToday'], resolve),
        }, {
          path: 'keJian',
          component: (resolve) => require(['@/views/main/keJian'], resolve),
        }, {
          path: 'user',
          component: (resolve) => require(['@/views/main/user'], resolve),
        },
      ],
    },
    {
      path: '/kecheng_details/:id',
      component: (resolve) => require(['@/views/kecheng_details'], resolve),
    },
    {
      path: '/kecheng_evaluate/:id',
      component: (resolve) => require(['@/views/kecheng_evaluate'], resolve),
    },
    {
      path: '/class_evaluate/:id',
      component: (resolve) => require(['@/views/class_evaluate'], resolve),
    },
    {
      path: '/subject_evaluate/:id',
      component: (resolve) => require(['@/views/subject_evaluate'], resolve),
    },
    {
      path: '/kejian_details/:id',
      component: (resolve) => require(['@/views/kejian_details'], resolve),
    },
    {
      path: '/kejian_evaluate/:id',
      component: (resolve) => require(['@/views/kejian_evaluate'], resolve),
    },
    {
      path: '/user_evaluate',
      component: (resolve) => require(['@/views/user_evaluate'], resolve),
    },
    {
      path: '/login',
      component: login,
    },
    {
      path: '/register',
      component: register,
    },
    {
      path: '/bind',
      component: bind,
    },
    {
      path: '/forgetPass',
      component: forgetPass,
    },
  ],
});
